const APP_NAME = 'Pricing Portal';

// Label first so it survives truncation in a narrow tab.
const STATIC_LABELS = {
  '/': 'Main',
  '/admin': 'Admin',
  '/reports': 'Reports',
  '/orders': 'Note Requests',
  '/my-artists': 'My Artists'
};

// Event pages carry the event name in ?name=, the same param Compare and Lion Auto read.
const EVENT_PAGES = [
  { prefix: '/compare/', label: 'Show', fallback: 'Compare' },
  { prefix: '/lion-auto/', label: 'Lion Pricer', fallback: '' }
];

/**
 * Browser tab title for a route, so several open tabs can be told apart.
 * @param {string} pathname location.pathname
 * @param {string} search location.search (may be empty)
 * @returns {string}
 */
export function pageTitle(pathname, search) {
  const eventPage = EVENT_PAGES.find((p) => pathname.startsWith(p.prefix));
  if (eventPage) {
    const name = (new URLSearchParams(search || '').get('name') || '').trim();
    const detail = name || eventPage.fallback;
    return detail ? `${eventPage.label} · ${detail}` : eventPage.label;
  }

  const label = STATIC_LABELS[pathname];
  return label ? `${label} · ${APP_NAME}` : APP_NAME;
}
